<template>
  <div>
    <iModal title="禁止直播" v-model="showModal" class-name="vertical-center-modal" width="500px" :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100" @submit.native.prevent>
            <FormItem label="禁止时间：" prop="time">
              <DatePicker type="datetime" placeholder="选择禁止时间" style="width: 300px" v-model="formInline.time"></DatePicker>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions } from "vuex";

export default {
  name: "set-live-time",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    const validTime = (rule, value, callback) => {
      if (value) {
        let now = new Date().getTime();
        let start = new Date(value).getTime();
        if (now > start) {
          callback(new Error("禁止时间不能小于当前时间"));
        } else {
          callback();
        }
        callback();
      } else {
        callback(new Error("禁止时间不能为空"));
      }
    };
    return {
      loading: false,
      showModal: true,
      time: [],
      formInline: {
        time: []
      },
      ruleInline: {
        time: [{ required: true, validator: validTime, trigger: "blur" }]
      }
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  created () {
    let info = this.info;
    if (info) {
      this.formInline.time = info.time;
    }
  },
  methods: {
    ...mapActions({
      updateLiveForbidTime: "liveModule/updateLiveForbidTime",
    }),
    async handleSubmit (name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        activityId: this.info.id,
        liveForbidTime: moment(this.formInline.time).format("YYYY-MM-DD HH:mm"),
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.updateLiveForbidTime(req).catch(err => {
        this.loading = false;
      });
      if (bool && bool.data && bool.data.live && bool.data.live.updateLiveForbidTime) { 
        this.$emit("finish");
        this.$Message.success("操作成功！");
        this.cancel();
      } else {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["formInline"].resetFields();
      this.formInline.time = ''
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

